






















import VueOptions from '@utils/VueOptions'
import PricingModel from '@services/PricingModel'

settings =
  name: "HostBoothEditor"
  vue:
    props: ['space', 'spaceSelected', 'spaceUpdated', 'event']

    data: ->
      price_in_dollars: 0

    created: ->
      @price_in_dollars = @space.supplier_price_in_dollars

    computed:
      parsedPrice: -> parseInt("#{@price_in_dollars}".replace(/,/g, ''))
      recessFee: -> PricingModel.recessFeeForEventSpace(@event, @parsedPrice)
      organizerPayout: -> PricingModel.payoutForEventSpace(@event, @parsedPrice)
    methods:
      imageForSpace: -> "#{process.env.VUE_APP_IMAGE_ENDPOINT}/spaces/#{@space.type}.png"

      hiPriceUpdated: ->
        @space.supplier_price_in_dollars = @parsedPrice
        @spaceUpdated(@space)

export default VueOptions.vue settings
